
  import { defineComponent, ref, onMounted, computed } from 'vue';
  import { useRouter } from 'vue-router';
  import { Form } from 'vee-validate';
  import { setCurrentPageBreadcrumbs } from '@/core/helpers/breadcrumb';
  import { toHtmlDocument } from '@/core/helpers/htmlDocument';
  import { useI18n } from 'vue-i18n/index';
  import { useStore } from 'vuex';
  import { Actions } from '@/store/enums/StoreEnums';
  import { useAbility } from '@casl/vue';
  import Swal from 'sweetalert2/dist/sweetalert2.js';
  import Editor from '@tinymce/tinymce-vue';

  export default defineComponent({
    name: 'finance-funds-request-about-editing',
    components: {
      editor: Editor,
      Form,
    },

    async setup() {
      const { t, te } = useI18n();
      const store = useStore();
      const router = useRouter();
      const { can } = useAbility();
      const submitButton = ref<HTMLButtonElement | null>(null);
      const translate = (text) => {
        if (te(text)) {
          return t(text);
        } else {
          return text;
        }
      };

      onMounted(() => {
        setCurrentPageBreadcrumbs(translate('realEstateAboutUpdating'), [
          translate('settings'),
        ]);
      });

      const about = await store.dispatch(
        Actions.GET_REAL_ESTATE_FUND_ABOUT,
        'finance'
      );
      const loading = ref(false);

      const goBack = () => {
        router.back();
      };

      const onSubmitUpdate = async () => {
        if (submitButton.value) {
          // eslint-disable-next-line
          submitButton.value!.disabled = true;
          submitButton.value.setAttribute('data-kt-indicator', 'on');
        }
        await EditorChangeAr(about.data.data.htmlAr);
        await EditorChangeEn(about.data.data.htmlEn);

        await store.dispatch(Actions.UPDATE_REAL_ESTATE_FUND_ABOUT, {
          data: {
            htmlAr: about.data.data.htmlAr,
            htmlEn: about.data.data.htmlEn,
            screen: 'finance',
          },
        });
        const [errorName] = Object.keys(store.getters.getErrors);
        const error = store.getters.getErrors[errorName];

        if (error) {
          Swal.fire({
            text: translate(error[0]),
            icon: 'error',
            buttonsStyling: false,
            confirmButtonText: translate('tryAgainExcl'),
            customClass: {
              confirmButton: 'btn fw-bold btn-light-danger',
            },
          });
          //Deactivate indicator
          submitButton.value?.removeAttribute('data-kt-indicator');
          // eslint-disable-next-line
          submitButton.value!.disabled = false;
        } else {
          Swal.fire({
            text: translate('SUCCESSFULLY_UPDATED_ABOUT_US'),
            icon: 'success',
            buttonsStyling: false,
            confirmButtonText: translate('ok'),
            customClass: {
              confirmButton: 'btn btn-light-primary',
            },
          }).then(() => {
            router.push({ name: 'finance-funds-request-about-overview' });
          });
        }
      };

      store.dispatch(Actions.REMOVE_BODY_CLASSNAME, 'page-loading-over');

      const EditorChangeAr = async (newContent) => {
        about.data.data.htmlAr = toHtmlDocument(newContent, 'rtl');
      };

      const EditorChangeEn = async (newContent) => {
        about.data.data.htmlEn = toHtmlDocument(newContent, 'ltr');
      };

      return {
        EditorChangeAr,
        EditorChangeEn,
        about,
        aboutUs: computed(() => store.getters.AboutUsView),
        translate,
        goBack,
        submitButton,
        onSubmitUpdate,
        loading,
        can,
      };
    },
  });
